<template>
  <v-dialog
    :value="show"
    @input="updateShow"
    width="500"
    class="rounded-xl"
    @click:outside="close"
  >
    <v-card class="pa-5">
      <v-card-actions class="modal-header">
        Workout Details
        <v-btn icon color="red" @click="close">
          <v-icon size="20">mdi-close</v-icon>
        </v-btn>
      </v-card-actions>
      <div v-if="loading" class="loading">
        <v-progress-circular size="64" width="4" color="red" indeterminate />
      </div>
      <div v-if="workoutData && loading === false" class="workout-details">
        <div class="workout-image">
          <img
            v-if="workoutType === 'coachedClass' || workoutType === 'live'"
            :src="getWorkoutImage(workoutData)"
            alt="Workout Preview"
          />
          <v-icon v-else size="64" color="grey">mdi-dumbbell</v-icon>
        </div>
        <div class="workout-name">{{ getWorkoutName(workoutData) }}</div>
        <div class="workout-id">ID: {{ workoutData?.id || "N/A" }}</div>
        <div class="workout-id" v-if="workoutType === 'byo'">
          Is shared: {{ workoutData?.isShared || "N/A" }}
        </div>
      </div>
      <div v-else-if="loading === false">Workout not found</div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "workout-modal",
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    workoutId: {
      type: String,
      required: true,
    },
    workoutType: {
      type: String,
      required: false,
      default: null,
    },
    userId: {
      type: String,
      required: false,
      default: null,
    },
    close: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      workoutData: null,
    };
  },
  methods: {
    updateShow(value) {
      if (!value) {
        this.close();
      }
    },
    async fetchWorkoutData() {
      if (!this.workoutId || !this.workoutType) return;
      
      this.loading = true;
      try {
        // Fetch workout data using workoutId, type, and userId
        const workoutData = await this.$store.dispatch("getWorkoutData", {
          workoutId: this.workoutId,
          type: this.workoutType,
          userId: this.userId,
        });
        this.workoutData = workoutData;
      } catch (error) {
        console.error("Error fetching workout data:", error);
      } finally {
        this.loading = false;
      }
    },
    getWorkoutName(item) {
      if (!item) return "";
      
      switch (this.workoutType) {
        case "coachedClass":
          return item.name || "Coached Class";
        case "live":
          return item.title?.ENG || "Live";
        case "byo":
          return item.name || "BYO";
        case "Freestyle":
          return item.name || "FreeStyle";
        case "preSet":
          return item.name?.ENG || "Pre Set";
        default:
          return "Workout";
      }
    },
    getWorkoutImage(workoutData) {
      if (this.workoutType === 'coachedClass') {
        return workoutData.selectedImagePreview.link;
      } else if (this.workoutType === 'live') {
        return workoutData.image.link;
      }
    },
  },
  watch: {
    workoutId: {
      immediate: true,
      handler() {
        this.fetchWorkoutData();
      },
    },
    workoutType: {
      immediate: true,
      handler() {
        this.fetchWorkoutData();
      },
    },
  },
};
</script>

<style scoped>
.modal-header {
  justify-content: space-between;
  font-size: 18px;
  color: #3a3a3a;
  font-weight: bold;
}
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
}
.workout-details {
  padding: 16px 0;
  text-align: center;
}
.workout-name {
  font-size: 16px;
  font-weight: bold;
  color: #3a3a3a;
  margin: 16px 0 8px;
}
.workout-id {
  font-size: 14px;
  color: #666;
}
.workout-image {
  margin-bottom: 16px;
}
.workout-image img {
  max-width: 100%;
  border-radius: 8px;
}
</style> 